import Vue from 'vue'
import Vuex from 'vuex'
import config from '../config/constants'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: false,
    user: {},
    breadcrumbs: [],
    snackbar: {
      timeout: 3000,
      status: false,
      message: '',
      color: ''
    },
    pageTitle: null,
    paginationOptions: {
    	rowsPerPage: 10,
    	perPageOptions: [10, 20, 30, 50]
    },
    currentPage: 1,
    itemsCount: 0,
    settings: {},
    cache: {},
    modules: {},
  },
  getters: {
    isLoggedIn: state => {
      return  Object.keys(state.user).length !== 0 && typeof state.user.id !== typeof undefined
    },
  	loggedInUser: (state, getters) => {
  		return getters.isLoggedIn ? state.user : null
  	},
    isSuperAdmin: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.superAdmin
    },
    isAdmin: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.admin
    },
    isSalesManager: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.salesManager
    },
    isBillingStaff: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.billingStaff
    },
    isShippingManager: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.shippingManager
    },
    isShippingStaff: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.shippingStaff
    },
    isAccountsStaff: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.accounts
    },
    isCommissionManager: (state, getters) => {
      return getters.isLoggedIn && parseInt(state.user.privilage) === config.userRoles.commissionManager
    },
    breadcrumbs: state => {
      return state.breadcrumbs
    },
    pageTitle: state => {
      return state.pageTitle
    },
    isLoading: state => {
      return state.loading
    },
    snackbar: state => {
      return state.snackbar
    },
    paginationOptions: state => {
      return state.paginationOptions
    },
    getCurrentPage: state => {
    	return state.currentPage
    },
    getItemsCount: state => {
    	return state.itemsCount
    },
    getAppSettings: state => {
      return state.settings
    },
    getCache: state => {
      return state.cache
    },
    getModules: state => {
      return state.modules
    },
  },
  mutations: {
    setLoading (state, status) {
      state.loading = status
    },
    setUser (state, data) {
      state.user = data
    },
    setBreadcrumbs (state, data) {
      state.breadcrumbs = data
    },
    setPageTitle (state, data) {
      state.pageTitle = data
    },
    notify (state, data) {
      state.snackbar.color = data.color || '' 
      state.snackbar.timeout = data.timeout || 2000 
      state.snackbar.message = data.message || ''
      state.snackbar.status = data.message ? true : false
    },
    setPerPage (state, data) {
      state.paginationOptions.rowsPerPage = data
    },
    setPage (state, data) {
    	state.currentPage = data
    },
    setItemsCount (state, data) {
    	state.itemsCount = data
    },
    setAppSettings (state, data) {
      state.settings = data
    },
    setCache (state, data) {
      state.cache[data.key] = data.data
    },
    setModules (state, data) {
      state.modules = data
    },
  }
})

export default store